import { render, staticRenderFns } from "./DecoBar.vue?vue&type=template&id=684d9b9f&scoped=true&"
import script from "./DecoBar.vue?vue&type=script&lang=ts&"
export * from "./DecoBar.vue?vue&type=script&lang=ts&"
import style0 from "./DecoBar.vue?vue&type=style&index=0&id=684d9b9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684d9b9f",
  null
  
)

export default component.exports